import { type DocumentNode, gql } from '@apollo/client';

const updateFieldMapsMutation: DocumentNode = gql`
  mutation update_field_map($externalFieldId: String, $fieldDefId: ID, $fieldMapId: ID!) {
    updateFieldMap(externalFieldId: $externalFieldId, fieldDefId: $fieldDefId, fieldMapId: $fieldMapId) {
      fieldMap {
        id
        fieldMapConfig {
          id
          name
        }
        externalFieldId
      }
    }
  }
`;

export default updateFieldMapsMutation;
